import { render, staticRenderFns } from "./DetailTipeBarang.vue?vue&type=template&id=766d2e5a&"
import script from "./DetailTipeBarang.vue?vue&type=script&lang=js&"
export * from "./DetailTipeBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports